module.exports = __webpack_public_path__ + "img/zhaf_01.21c9fcf9.jpg";